'use client';

import { usePathname } from 'next/navigation';
import DynamicJsonLd from './dynamic-json-ld';

export default function SeoManager() {
  const pathname = usePathname();

  return <DynamicJsonLd type='all' pathname={pathname} />;
}
